<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="8">
        <b-form onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              v-model="form.searchKey"
              @keyup.enter="clickQuery"
              type="search"
              placeholder="输入关键字快速搜索..."
              size="sm"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="visible = !visible"
                  >
                    高级搜索
                  </b-button>
                  <b-button variant="primary" size="sm" @click="clickQuery">
                    <i class="fa fa-search"></i>
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      title="高级搜索"
      :show-close="true"
      :visible.sync="visible"
      width="600px"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form ref="form" :model="form" label-width="100px">
        <el-row :gutter="20">
          <el-form-item :label="$l('INDEX.label_request_billno') || '申请单号'"
            ><el-col :span="24">
              <el-input
                v-model="form.fabricRequestNo"
                clearable
                size="small"
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item
            :label="$l('INDEX.choose_fabric_fabricNo') || '面料编号'"
            ><el-col :span="24">
              <el-input
                v-model="form.fabricNo"
                clearable
                size="small"
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item
            :label="$l('INDEX.choose_fabric_fabricName') || '面料名称'"
            prop="patternArray"
            ><el-col :span="24">
              <el-input
                v-model="form.fabricName"
                clearable
                size="small"
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item
            :label="$l('INDEX.choose_fabric_content') || '成分'"
            prop="patternArray"
            ><el-col :span="24">
              <el-input
                v-model="form.fabricContent"
                clearable
                size="small"
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item :label="$l('INDEX.choose_fabric_supName') || '供应商'"
            ><el-col :span="24">
              <dict-select
                clearable
                filterable
                style="width: 100%"
                size="small"
                v-model="form.scmCode"
                 url="/master/common/dict/scmCooperated"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              ></dict-select>
            </el-col>
          </el-form-item>
          <el-form-item :label="$l('INDEX.choose_fabric_agent') || '业务人员'"
            ><el-col :span="24">
              <dict-select
                v-model="form.fabricAgentCode"
                url="/digitalCenter/common/dict/baseUser"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                style="width: 100%"
                filterable
                :multiple="false"
                clearable
                :options="{ label: 'label', value: 'code' }"
              ></dict-select>
            </el-col>
          </el-form-item>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消查询</el-button>
        <el-button size="small" type="warning" @click="onReset"
          >重置条件</el-button
        >
        <el-button size="small" type="primary" @click="clickQuery"
          >数据检索</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
      form: {
        searchKey: '',
        fabricRequestNo: '',
        fabricNo: '',
        fabricName: '',
        fabricContent: '',
        scmCode: '',
        fabricAgentCode: '',
      },
    }
  },
  mounted() {
    this.onReset()
  },
  activated() {},
  methods: {
    closeDialog() {
      this.visible = false
    },
    clickQuery() {
      this.$emit('reset')
      this.query()
    },
    query() {
      this.$emit('submit', this.form)
      this.visible = false
    },
    onReset() {
      this.form = {
        searchKey: '',
        fabricRequestNo: '',
        fabricNo: '',
        fabricName: '',
        fabricContent: '',
        scmCode: '',
        fabricAgentCode: '',
      }
      this.clickQuery()
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
